/* GASSISA
=========================================================================================
* Descripción: Submenú de acciones delicadas para formularios transaccionales
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 01/06/2026 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import { Fragment, useState } from "react";
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDoubleClickPrevention } from "../../hooks/useDoubleClickPrevention";

export default function MnuDangerActionsMenu({
  label = "Menu",
  tooltip = "Otras acciones",
  actions = [],
  disabled = false,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const { isProcessing, executeWithProtection } = useDoubleClickPrevention();
  const open = Boolean(anchorEl);
  const hasEnabledAction = actions.some((action) => !action.disabled);
  const menuDisabled = disabled || isProcessing || !hasEnabledAction;

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickAction = (action) => {
    handleClose();
    executeWithProtection(action.onClick);
  };

  return (
    <Fragment>
      <Tooltip title={tooltip}>
        <span>
          <IconButton onClick={handleOpen} disabled={menuDisabled}>
            <MenuIcon className="icon" />
            <p className="icon">{label}</p>
          </IconButton>
        </span>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {actions.map((action) => {
          const Icon = action.icon || DeleteIcon;
          return (
            <MenuItem
              key={action.label}
              onClick={() => handleClickAction(action)}
              disabled={isProcessing || action.disabled}
            >
              <ListItemIcon>
                <Icon fontSize="small" color={action.color || "error"} />
              </ListItemIcon>
              <ListItemText>{action.label}</ListItemText>
            </MenuItem>
          );
        })}
      </Menu>
    </Fragment>
  );
}
